export default __webpack_public_path__ + "static/media/mShorts_1_p2.eb4530d4.jpeg";